// extracted by mini-css-extract-plugin
module.exports = {"gradient":"Application-module__gradient___3Eb5n","footerLink":"Application-module__footerLink___3j-40"};